import { useState, useEffect, useCallback } from 'react'

interface UseKeyboardShortcutsParams {
  onNextAnnotation: () => void
  onPrevAnnotation: () => void
}

interface UseKeyboardShortcutsResult {
  isDrawing: boolean
  setIsDrawing: (value: boolean | ((prev: boolean) => boolean)) => void
}

export function useKeyboardShortcuts({
  onNextAnnotation,
  onPrevAnnotation
}: UseKeyboardShortcutsParams): UseKeyboardShortcutsResult {
  const [isDrawing, setIsDrawing] = useState(false)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      // Ignore if user is typing in an input field
      const target = e.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return
      }

      if (e.key === 'b' || e.key === 'B') {
        e.preventDefault()
        setIsDrawing(v => !v)
      } else if (e.key === 'Escape') {
        if (isDrawing) {
          e.preventDefault()
          setIsDrawing(false)
        }
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault()
        onPrevAnnotation()
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
        onNextAnnotation()
      }
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [isDrawing, onNextAnnotation, onPrevAnnotation])

  return {
    isDrawing,
    setIsDrawing
  }
}

